export default __webpack_public_path__ + "static/media/whatsapp.9bc71b09.svg";